import type { IconData } from '@stacksjs/iconify-core'

export const barcode: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 464h480V56H16ZM48 88h416v344H48Z\"/><path fill=\"currentColor\" d=\"M80 128h32v256H80zm64 0h32v192h-32zm64 0h32v256h-32zm64 0h32v192h-32zm64 0h32v192h-32zm64 0h32v256h-32zM144 352h32v32h-32zm128 0h32v32h-32zm64 0h32v32h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default barcode
